const prefix = 'tracker';

export const getAllTrackers = `${prefix}`;
